import { H5, H6 } from '@components/Typography';
import { ErrorImg, Root, RootWrapper } from './styles';

import hubby_m_01 from '@assets/images/hubby_m_01.png';
import Button from '@components/Button';
import { Column } from '@components/LinearLayout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useEffect } from 'react';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    navigate(`${t('404-url')}`);
  }, []);

  return (
    <Root>
      <RootWrapper>
        <ErrorImg src={hubby_m_01} alt="404 Page Not Found Illustration" />
        <Column $gap="1rem">
          <H5>{t('page-not-found')}</H5>
          <H6>{t('page-not-found-subtitle')}</H6>
        </Column>

        <Button
          title={t('go-back-to-home-page')}
          backgroundColor={theme.color.mobilityBlue}
          hoverBackgroundColor={theme.color.mobilityGrey}
          textColor={theme.color.white}
          borderRadius={theme.borderRadius.radius10}
          padding="0.5rem 2.5rem"
          width="max-content"
          onClick={() => {
            navigate('/');
          }}
        />
      </RootWrapper>
    </Root>
  );
};

export default NotFound;
